import moment from 'moment';

import { BusinessDownloadConfig } from '../types';
import { ECHARTS_DATASOURCE_METRICS_CONSOLE } from '@/pages/intelligence/utils/constant';
import { DATASOURCE_METRICS_VALUE_CONSOLE } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/constant';
import { TOPCHARTS_COMMON_DOWNLOAD_API, publisherCheckboxList, storeRankTopBasicInfoFormItem, storeRankTopRankingsFormItem } from './common';

const storeRankTopConsoleFormList = [
  {
    label: 'dbi_label_time_settings',
    type: 'dateRangeDay' as const,
    defaultValue: [defaultDate, defaultDate],
    field: 'dateRange',
    options: [],
  },
  storeRankTopRankingsFormItem,
  storeRankTopBasicInfoFormItem,
];

const defaultDate = moment().format('YYYY-MM-DD');

// Console 页不展示，PC/PC&Console 页新增的 stream_id 字段
const consolePublisherCheckboxList = {
  ...publisherCheckboxList,
  defaultValue: {
    ...publisherCheckboxList.defaultValue,
    steam_id_show: undefined,
  },
  options: publisherCheckboxList?.options?.slice(0, -1),
};

const consoleConfig: BusinessDownloadConfig = {
  'console-MetricsTable': {
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        className: 'dbi-top-companies-source-metric-selector',
        label: 'dbi_label_metrics',
        type: 'cascadeMetricSelector',
        field: 'metrics',
        defaultValue: DATASOURCE_METRICS_VALUE_CONSOLE,
        cascadeOptions: ECHARTS_DATASOURCE_METRICS_CONSOLE,
      },
      consolePublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
    bubbleText: 'dbi_info_download_tip',
  },
  'console-DigitalRevenue': {
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'metrics',
        defaultValue: ['digitalRevenue', 'units', 'digitalARPPU', 'ast'],
        options: [
          {
            label: 'dbi_metric_digitalRevenue',
            value: 'digitalRevenue',
            disabled: false,
            message: '',
          },
          { label: 'dbi_metric_units', value: 'units', disabled: false, message: '' },
          {
            label: 'dbi_metric_digital_arpu_$',
            value: 'digitalARPPU',
            disabled: false,
            message: 'Digital ARPPU($) is only available when US is selected.',
          },
          { label: 'dbi_metric_ast_$', value: 'ast', disabled: false, message: '' },
        ],
      },
      consolePublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_segment_settings',
            type: 'checkboxGroup',
            defaultValue: [
              'Full Game',
              'DLC: All Other',
              'DLC: Expansion',
              'DLC: Content Pre-Purchase Pass',
              'DLC: Unlockable Content Pass',
              'MTX',
              'Subscription',
            ],
            field: 'download_segments',
            options: [
              { label: 'Base Game', value: 'Full Game', disabled: false, message: '' },
              { label: 'DLC: All Other', value: 'DLC: All Other', disabled: false, message: '' },
              { label: 'DLC: Expansion', value: 'DLC: Expansion', disabled: false, message: '' },
              {
                label: 'DLC: Season Pass',
                value: 'DLC: Content Pre-Purchase Pass',
                disabled: false,
                message: '',
              },
              {
                label: 'DLC: Battle Pass',
                value: 'DLC: Unlockable Content Pass',
                disabled: false,
                message: '',
              },
              { label: 'MTX', value: 'MTX', disabled: false, message: '' },
              { label: 'Subscription', value: 'Subscription', disabled: false, message: '' },
            ],
          },
          {
            label: 'dbi_label_device_settings',
            type: 'checkboxGroup',
            defaultValue: ['PlayStation', 'Xbox', 'Nintendo'],
            field: 'download_devices',
            options: [
              { label: 'PlayStation', value: 'PlayStation', disabled: false, message: '' },
              { label: 'Xbox', value: 'Xbox', disabled: false, message: '' },
              { label: 'Nintendo', value: 'Nintendo', disabled: false, message: '' },
            ],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
    bubbleText:
      'dbi_info_download_tip',
  },
  'console-PhysicalRevenue': {
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'metrics',
        defaultValue: ['revenue', 'physical_units'],
        options: [
          { label: 'dbi_metric_physical_revenue', value: 'revenue' },
          { label: 'dbi_metric_physical_units', value: 'physical_units' },
        ],
      },
      consolePublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_device_settings',
            type: 'checkboxGroup',
            defaultValue: [
              'PlayStation 4',
              'PlayStation 5',
              'Xbox One',
              'Xbox Series X|S',
              'Nintendo Switch',
              'Nintendo Wii U',
            ],
            field: 'download_devices',
            options: [
              { label: 'PlayStation 4', value: 'PlayStation 4', disabled: false, message: '' },
              { label: 'PlayStation 5', value: 'PlayStation 5', disabled: false, message: '' },
              { label: 'Xbox One', value: 'Xbox One', disabled: false, message: '' },
              { label: 'Xbox Series X|S', value: 'Xbox Series X|S', disabled: false, message: '' },
              { label: 'Nintendo Switch', value: 'Nintendo Switch', disabled: false, message: '' },
              { label: 'Nintendo Wii U', value: 'Nintendo Wii U', disabled: false, message: '' },
            ],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
    bubbleText:
      'dbi_info_download_tip',
  },
  'console-MAU': {
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'metrics',
        defaultValue: ['mau', 'acquisition'],
        options: [
          { label: 'dbi_mau', value: 'mau' },
          { label: 'dbi_metric_acquisition', value: 'acquisition' },
        ],
      },
      consolePublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_device_settings',
            type: 'checkboxGroup',
            defaultValue: ['PlayStation 4', 'PlayStation 5', 'Xbox One', 'Xbox Series X|S'],
            field: 'download_devices',
            options: [
              { label: 'PlayStation 4', value: 'PlayStation 4', disabled: false, message: '' },
              { label: 'PlayStation 5', value: 'PlayStation 5', disabled: false, message: '' },
              { label: 'Xbox One', value: 'Xbox One', disabled: false, message: '' },
              { label: 'Xbox Series X|S', value: 'Xbox Series X|S', disabled: false, message: '' },
            ],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
    bubbleText:
      'dbi_info_download_tip',
  },
  'console-LifeTimePlayers': {
    apiUrl: TOPCHARTS_COMMON_DOWNLOAD_API,
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'metrics',
        defaultValue: ['lifetime_player'],
        options: [{ label: 'dbi_lifetime_players', value: 'lifetime_player' }],
      },
      consolePublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_device_settings',
            type: 'checkboxGroup',
            defaultValue: ['PlayStation 4', 'PlayStation 5', 'Xbox One', 'Xbox Series X|S'],
            field: 'download_devices',
            options: [
              { label: 'PlayStation 4', value: 'PlayStation 4', disabled: false, message: '' },
              { label: 'PlayStation 5', value: 'PlayStation 5', disabled: false, message: '' },
              { label: 'Xbox One', value: 'Xbox One', disabled: false, message: '' },
              { label: 'Xbox Series X|S', value: 'Xbox Series X|S', disabled: false, message: '' },
            ],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            // message:
            //   'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
    bubbleText:
      'dbi_info_download_tip',
  },
  'console-newRelease': {
    apiUrl: 'api/v1/intelligence_pc/pcConsoleNewReleaseExcel',
    bubbleText: '',
    translate: true,
    formList: [consolePublisherCheckboxList],
  },
  'console-upcoming': {
    apiUrl: 'api/v1/intelligence_pc/pcConsoleUpcomingExcel',
    bubbleText: '',
    translate: true,
    formList: [consolePublisherCheckboxList],
  },
  'console-store-rank-more': {
    apiUrl: '/api/v1/intelligence_pc/topChartsMobileStoreRankExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_time_settings',
        type: 'dateRangeDay',
        defaultValue: [defaultDate, defaultDate],
        field: 'dateRange',
        options: [],
      },
    ],
  },
  'console-ps-store-rank-top': {
    apiUrl: '/api/v1/intelligence_pc/topChartsMobileStoreRankExcel',
    bubbleText: '',
    translate: true,
    formList: storeRankTopConsoleFormList,
  },
  'console-xbox-store-rank-top': {
    apiUrl: '/api/v1/intelligence_pc/topChartsMobileStoreRankExcel',
    bubbleText: '',
    translate: true,
    formList: storeRankTopConsoleFormList,
  },
  'console-nintendo-store-rank-top': {
    apiUrl: '/api/v1/intelligence_pc/topChartsMobileStoreRankExcel',
    bubbleText: '',
    translate: true,
    formList: storeRankTopConsoleFormList,
  },
  'topcharts-console-japan-sales': {
    apiUrl: '/api/v1/intelligence_pc/japanSalesExcel',
    bubbleText:
      'dbi_info_download_tip',
    translate: true,
    formList: [
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['sales', 'price', 'revenue', 'cumulative_sales', 'cumulative_revenue'],
        options: [
          { label: 'dbi_top_sales_of_selected_time$', value: 'sales' },
          { label: 'dbi_top_price', value: 'price' },
          { label: 'dbi_top_revenue_of_selected_time$', value: 'revenue' },
          { label: 'dbi_top_cumulative_sales_of_the_latest_week', value: 'cumulative_sales' },
          { label: 'dbi_top_cumulative_revenue_of_the_latest_week', value: 'cumulative_revenue' },
        ],
      },
      consolePublisherCheckboxList,
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            message: '',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              // { label: 'dbi_label_separate_by_country', value: 'market' },
              // { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },

          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },
};

export default consoleConfig;
